module.exports = __webpack_public_path__ + "img/Kleber Melo e Silva.e255bf0c.jpg";